import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

export interface CommentPayload {
    object_id: string;
    object_type: 'POST';
    parent_id: string;
    content: string;
    message_ranges: any[];
    medias: any[];
    language: string;
    preview_data: any;
    owner_type: 'USER';
}

@Injectable({
  providedIn: 'root'
})
export class CommentService {
    private readonly base = `${environment.baseURL}/comment/comments`;

    constructor(private http: HttpClient) {}
  
    list(objectId: string, page = 0, size = 10) {
      return this.http.get<any>(
        `${this.base}/${objectId}?isLivestream=false&pageNum=${page}&pageSize=${size}&referenceType=TIME_DESC`
      );
    }
  
    create(body: CommentPayload) {
      return this.http.post<any>(this.base, body);
    }
  
    update(id: string, body: CommentPayload) {
      return this.http.put<any>(`${this.base}/${id}`, body);
    }
  
    remove(id: string) {
      return this.http.delete<any>(`${this.base}/${id}`);
    }
}
